import React, { useContext, useEffect, useState } from "react";
import { Panel } from "../../../common/components/panel/panel";
import StandAloneContext from "../../../common/components/context/StandAloneContext";
import { ErrorColumnsDefinitions } from "../Error/ErrorColumnsDefinitions";
import { GetValidationErrorsByImportId,GetYearEndImportById } from "../../../services/ImportDetailService";
import { StandAloneActions, Status } from "../../../models/StandAloneData";
import { YearEndColumnsDefinitions } from "../YearEnd/YearEndColumnsDefinition";
import YearEndBoxValueModel, { CompanyImportData } from "./YearEndBoxValueModel";
import { TableV } from "../../../common/components/table/tablev2";
import logger from '../../../logger';

export const YearEndFile: React.FC<{ rowsPerPage?: any}> = ({
    rowsPerPage = 25,
  }) => {

    const [errors, setErrors] = useState(false);
    const { state , dispatch } = useContext(StandAloneContext);
    const [loadingError, setLoadingError] = useState(true);
    const [errorData, setErrorData] = useState<any[]>([]);
    const [loadingPayRun, setLoadingPayRun] = useState(true);
    const [payData, setpayData] = useState([]);
    const [showBoxValueModalOpen, setshowBoxValueModalOpen] = useState(false);
    const [currentFile, setCurrentFile] = useState<CompanyImportData | null>(null);    

    async function GetYEDetails() {
            try {
                const response =  await GetYearEndImportById(state.importId);
                if(response) {
                    const data = {
                        fileName: state?.fileName,
                        RunDate: response?.runDate,
                        taxYear: response?.taxYear,
                        companyName: response?.transmitterCompanyName,                     
                        t4SlipCount: response?.t4SlipCount                       
                    };
                    dispatch({
                        type: StandAloneActions.SET_IMPORT_DETAIL,
                        payload: { 
                            ...state,
                            importDetailId: response?.importDetailsId,
                        },
                    });
                    setpayData([data]);
                    // Create currentFile object for YearEndBoxValueModel
                    setCurrentFile({
                        companyName: response?.transmitterCompanyName || '',
                        companyId: '',
                        importId: state.importId,
                        importDetailsId: response?.importDetailsId || 0,
                        userId: 0,
                        companyStatus: true,
                        fileName: state?.fileName || '',
                        fileType: state?.fileType || 0,
                        containerType: 0,
                        submissionType: 0,
                        isProduction: false,
                        status: state?.status || 0,
                        createdOn: '',
                    });
                }            
                setLoadingPayRun(false);
            } catch (error) {
                return new Error(error)
            }
        };
    async function getValidationErrors() {
        try {
            const resp = await GetValidationErrorsByImportId(state.importId);
            if(resp && resp.length > 0) {
                setErrorData(resp);
            }
            setLoadingError(false);
        } catch (error) {
            setLoadingError(false);
            logger.error(error); 
        }
    };
    
    const handleReportClick = () => {      
         setshowBoxValueModalOpen(true);
    };
    
    useEffect(() => {
        if(state.status === Status.Error || state.status === Status.TransmissionError) {
            getValidationErrors();
            setErrors(true);
            // Debug message gated to non-production builds; avoid dumping full state
            if (process.env.NODE_ENV !== 'production') {
                logger.debug('YearEnd import encountered error status');
            }
        } 
        else {
            GetYEDetails(); 
        }
    }, [state.status]);

    return (
        <>
            <Panel fullWidth={true}>
                        {!errors && 
                            <Panel.Block>
                                <TableV
                                    testId={"canada-standalone-ui-pay"} 
                                    isLoading={loadingPayRun}
                                    columns={YearEndColumnsDefinitions(handleReportClick)} 
                                    data={payData} 
                                    dataKey={"Canada"}
                                    dataLength={null} 
                                    description={"YearEnd File Data"} 
                                    noDataText={"No Data Available"}
                                    addItemText={""}
                                    tableHeight="30vh"
                                    rowsPerPage={rowsPerPage}
                            />
                        </Panel.Block> 
                        }    
                    {errors && 
                    <Panel.Block>
                        <TableV
                            testId={"canada-standalone-ui-YearEnd-error"}
                            isLoading={loadingError} 
                            columns={ErrorColumnsDefinitions()} 
                            data={errorData} 
                            dataKey={"Canada"}
                            dataLength={null} 
                            description={"YearEnd Error Data"} 
                            noDataText={""}
                            addItemText={""}
                            tableHeight="83vh"
                            rowsPerPage={rowsPerPage}
                        />
                    </Panel.Block>
                     }
           </Panel>
        
<YearEndBoxValueModel show={showBoxValueModalOpen} onClose={() => setshowBoxValueModalOpen(false)} currentFile={currentFile} containerTypeLookup={{}} />
        </>
    );
}
